<nav class="fm-global-navgiation" role="navigation">
  <div class="internaluser" *ngIf="isHeaderBanner">
    <span class="text-size">{{ messageBody }}</span>
    <span class="float-end text-size">
      <a (click)="exitToRCRRequestPage()"
        ><span aria-hidden="true">&#10006;</span> LOGOUT AS USER</a
      ></span
    >
  </div>

  <div class="container-fluid">
    <div class="fm-navigation-logo">
      <a class="site-logo" href="http://www.fanniemae.com" target="_blank" title="Fannie Mae">
        <img src="assets/FannieMae-Logo.svg" width="242" height="72" alt="Fannie Mae" />
      </a>

      <div class="site-logo-print">
        <img src="assets/images/FM_logo_pdf.png" width="211" height="43" alt="Fannie Mae" />
      </div>
    </div>
    <div
      class="collapse-menu authentication-panel"
      [ngClass]="{ 'collapse-menu': true, 'authentication-panel': true, visible: isVisible }"
      id="fm-header-navbar-collapse"
    >
      <div class="app-dropdown">Structured Transactions</div>

      <div class="right-align">
        <div class="authentication-panel__user-info authentication-panel__user-info_p-top">
          <div>
            <span class="authentication-panel__user-info_first-name">{{
              userName?.firstName
            }}</span>
            <span class="authentication-panel__user-info_last-name">{{ userName?.lastName }}</span>
          </div>

          <invd-fm-dropdown class="user-dropdown" title="">
            <ng-container *ngFor="let link of userLinks; trackBy: trackByIdentity">
              <a href="{{ link.url }}">{{ link.title }}</a>
            </ng-container>
          </invd-fm-dropdown>
        </div>
      </div>
    </div>
  </div>
</nav>
